<div class="login-page flex flex-row items-center justify-center">
  <div class="login-page__content flex flex-row justify-center">
    <figure class="mat-figure flex w-1/2 flex-row items-center justify-center">
      <div class="login-page__form-layout">
        <div class="login-page__bg-img"></div>
        <div class="login-page__info"></div>
        <div class="login-page__info-welcome">
          <h2>{{ 'LOGIN.WELCOME_TITLE' | translate }}</h2>
          <div class="login-page__info-logo">
            <mat-icon svgIcon="logo-login" />
          </div>
        </div>
      </div>
    </figure>
    <figure class="mat-figure flex w-1/2 flex-row items-center justify-center">
      <div
        class="login-page__form"
        [class.step-login]="!stepEmail() && !stepPassword()"
        [class.step-email]="stepEmail()"
        [class.step-password]="stepPassword() || requireNewPassword()"
        [class.has-error]="errorSignIn()"
        [class.step-select-bp]="loggedIn() && !requireNewPassword()"
        [class.loading-bps]="authPending()"
      >
        <mat-card>
          <mat-card-title>{{ 'LOGIN.TITLE.LOGIN' | translate }}</mat-card-title>
          @if (!loggedIn() && !stepEmail() && !stepPassword() && !loginWithEmailPassword() && !requireNewPassword()) {
            <iot-platform-login-form
              data-cy="iot-platform-login-form"
              [ssoDisabled]="!!authConfig()?.ssoDisabled"
              [rememberMe]="!!authConfig()?.rememberMe"
              [isI4BLogin]="false"
              [hasError]="errorSignIn()"
              (cancel)="onCancel()"
              (resetPassword)="onResetPassword()"
              (signIn)="onSignIn($event)"
            />
          }

          @if (requireNewPassword()) {
            <iot-platform-login-change-temporary-password-form
              data-cy="iot-platform-login-change-temporary-password-form"
              [hasError]="errorPassword()"
              (cancel)="onCancel()"
              (changeTemporaryPassword)="onChangeTemporaryPassword($event)"
            />
          }

          @if (stepEmail()) {
            <iot-platform-login-send-code-form
              data-cy="iot-platform-login-send-code-form"
              [hasError]="errorEmail()"
              [isI4BLogin]="false"
              (cancel)="onCancel()"
              (sendCode)="onSendCode($event)"
            />
          }

          @if (stepPassword()) {
            <iot-platform-login-reset-password-form
              data-cy="iot-platform-login-reset-password-form"
              [username]="username()"
              [hasError]="errorPassword()"
              (cancel)="onCancel()"
              (sendCode)="onSendCode($event)"
              (changePassword)="onChangeForgottenPassword($event)"
            />
          }

          @if (loggedIn() && !requireNewPassword() && !stepPassword()) {
            <iot-platform-login-select-profile
              data-cy="iot-platform-login-select-profile"
              [businessProfiles]="eligibleBusinessProfiles()"
              [loading]="authPending()"
              (selectProfile)="onSelectProfile($event)"
            />
          }
        </mat-card>
      </div>
    </figure>
  </div>
  <div class="login-page__footer" [class.step-password]="stepPassword()">
    <mat-icon svgIcon="al-colored-logo" />
  </div>
</div>
